import { getComponentInFormElement } from '@gig/magic-form-builder';

function setReverseMonth(dateWrapper, info) {
    var date = getComponentInFormElement(dateWrapper, 'magic-ui-date');
    if (!date) {
        return;
    }
    date.properties['reverse-month'] = true;
    if (info) {
        date.properties.info = info;
    }
}

export { setReverseMonth };
